import { BidReportEntry_Answer_Sources } from "lib/generated/app-service-gql/graphql";
import { AiSourceType, inferEnumType } from "lib/types/graphQLEnums";
import { AiDocumentSource, AiSource } from "../../ai_chat/types";

/**
 * Delay (ms) before resetting dropdown state after close,
 * so the user can see the "Link copied" confirmation message.
 */
export const DROPDOWN_CLOSE_DELAY_MS = 500;

// TODO: When fully migrated to inline citations + streaming, we can just use aiSources as the type in the backend
// Converts BidReportEntry_Answer_Sources to AiSource[] for inline citation rendering.
// type and citationId come directly from the stored data for new rows. For legacy rows
// (stored before the schema migration) type will be null — those fall back to document.
export function toInlineSources(
  sources: BidReportEntry_Answer_Sources[],
  noticeId?: string,
): AiSource[] {
  return sources.flatMap((s, i): AiSource[] => {
    const citationId = s.citationId ?? String(i + 1);
    const sourceType = s.type ?? (s.documentId ? "document" : null);

    if (sourceType === "notice") {
      return [
        {
          type: AiSourceType.Notice,
          id: noticeId ?? s.id ?? "",
          title: s.title ?? s.fileName ?? "Notice",
          citationId,
        },
      ];
    }
    if (sourceType === "website" && s.url) {
      return [{ type: AiSourceType.Website, title: s.title ?? "", url: s.url, citationId }];
    }
    if (sourceType === "document" || s.id || s.documentId) {
      return [
        {
          type: AiSourceType.Document,
          id: s.id ?? s.documentId ?? "",
          title: s.title ?? s.fileName ?? "",
          citationId,
          documentType: inferEnumType(s.documentType),
          chunkNumber: s.chunkNumber ?? 0,
          locations: (s.locations ?? []) as AiDocumentSource["locations"],
          isDeleted: s.isDeleted ?? false,
        },
      ];
    }
    return [];
  });
}
